import variables from './cssInJs/variables';
import { getIdToken } from './lib/auth/services/authHelper';

const cssEmotion = {
  breakpointNames: variables.breakpointNames,
  breakpoints: variables.breakpoints
}

const firebaseSettings = {
  apiKey: "AIzaSyD2OUq4Z3c40ipXfKWoDr0IEPHvdzvdBNo",
  authDomain: "freemasonry-1e370.firebaseapp.com",
  // databaseURL: "https://jaba-pwa.firebaseio.com",
  projectId: "freemasonry-1e370",
  storageBucket: "freemasonry-1e370.appspot.com",
  messagingSenderId: "539789169520",
  appId: "1:539789169520:web:fc8a4b4655c5f4e47e75b5"
}

const apiNetJwt = async (options) => {
  const token = await getIdToken();
  //console.log(token)
  if (token) {
    options.headers = options.headers || {}
    options.headers['Authorization'] = `Bearer ${token}`
  }
}

export default {
  cssEmotion,
  firebaseSettings,
  apiNetJwt
}